import { Alert, Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import DateField from '../../../../../components/modals/components/DateFieldOk';
import type { DisplayedSubjectQuote } from '../../../../../types';
import DocumentsFormSection from '../../../../documents/external-components/DocumentsFormSection/DocumentsFormSection';
import useAcceptQuoteModal from './useAcceptQuoteModal';

type Props = {
  quote: DisplayedSubjectQuote;
  subjectId: string;
  onClose: () => void;
};

export default function AcceptQuoteModal(props: Props) {
  const hook = useAcceptQuoteModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      maxWidth="sm"
      fullWidth
      title={hook.isAlreadyAccepted ? 'Mettre à jour le bon pour accord' : 'Donner le bon pour accord'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Valider le bon pour accord',
          onClick: hook.handleSubmit,
          loading: hook.isLoading,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isLoading,
        },
      }}
    >
      <Stack spacing={3}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Stack spacing={0.5}>
          <Typography variant="body1Emphasis">{hook.providerName}</Typography>
          {props.quote.title ? <Typography variant="body2">{props.quote.title}</Typography> : null}
          {hook.formattedAmount ? <Typography variant="body1Emphasis">{hook.formattedAmount}</Typography> : null}
        </Stack>

        <DateField
          name="date"
          form={hook.form}
          label="Date du bon pour accord"
          isTimeManaged={false}
          required
        />

        <Stack spacing={1}>
          <Typography variant="body2">
            Joignez le devis signé maintenant ou plus tard (facultatif).
          </Typography>
          <Controller
            name="documents"
            control={hook.form.control}
            render={({ field }) => (
              <DocumentsFormSection
                documents={field.value}
                onChange={field.onChange}
                subjectId={props.subjectId}
                defaultDocumentType="Bon pour accord"
                hideType
              />
            )}
          />
        </Stack>
      </Stack>
    </Dialog>
  );
}
